// En tu store Vuex
// Agrega estas importaciones al principio de tu archivo Vuex
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    cartItems: [], // Estado inicial del carrito
  },
  mutations: {
    // Mutación para agregar un producto al carrito
    agregarAlCarrito(state, item) {
      state.cartItems.push(item);
    },
    // Mutación para cargar el carrito desde localStorage
    cargarCarritoDesdeLocalStorage(state, carrito) {
      state.cartItems = carrito;
    },
    // Otras mutaciones si es necesario
  },
  actions: {
    // Acción para agregar un producto al carrito
    agregarAlCarrito({ commit }, item) {
      commit('agregarAlCarrito', item);
    },
    // Acción para cargar el carrito desde localStorage
    cargarCarritoDesdeLocalStorage({ commit }, carrito) {
      commit('cargarCarritoDesdeLocalStorage', carrito);
    },
    // Otras acciones si es necesario
  },
  getters: {
    // Getter para obtener la cantidad de elementos en el carrito
    cartItemCount: state => state.cartItems.length,
    // Otros getters si es necesario
  },
});
